import { z } from 'zod'

/**
 * 參數類別 Schema
 */
export const parametermDataSchema = z.object({
  /** 類別代碼 */
  pmCode: z.string(),
  /** 類別名稱 */
  pmName: z.string()
})

/**
 * 參數類別
 */
export interface ParametermData extends z.infer<typeof parametermDataSchema> {}
